import { render, staticRenderFns } from "./StoreSelector.vue?vue&type=template&id=2a179945&scoped=true"
import script from "./StoreSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./StoreSelector.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StoreSelector.vue?vue&type=style&index=0&id=2a179945&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a179945",
  null
  
)

export default component.exports